import { extendObservable } from 'mobx'

class ActiveProjectStore {
  constructor (growlStore) {
    extendObservable(this, {
      growlStore,
      activeProjectId: Number(localStorage.getItem('activeProjectId')),
      activeProjectName: localStorage.getItem('activeProjectName'),
      isActiveProjectLocked:
        localStorage.getItem('isActiveProjectLocked') === 'true'
    })
  }

  markProjectAsActive = (projectId, projectName) => {
    localStorage.setItem('activeProjectId', projectId)
    localStorage.setItem('activeProjectName', projectName)
    this.activeProjectId = projectId
    this.activeProjectName = projectName
  }

  toggleLock = (projectId, projectName) => {
    if (this.isProjectLocked(projectId)) {
      this.resetLock()
    } else {
      this.markProjectAsActive(projectId, projectName)
      localStorage.setItem('isActiveProjectLocked', true)
      this.isActiveProjectLocked = true
      this.growlStore.showSuccess('Active project selected.')
    }
  }

  resetLock = () => {
    localStorage.setItem('isActiveProjectLocked', false)
    this.isActiveProjectLocked = false
    this.growlStore.showSuccess('Active project deselected.')
  }

  isProjectLocked = projectId => {
    return (
      localStorage.getItem('isActiveProjectLocked') === 'true' &&
      Number(localStorage.getItem('activeProjectId')) === projectId
    )
  }
}

export default ActiveProjectStore
